module.exports = __webpack_public_path__ + "img/Skirt-Front-B3-Da-Ge-Ha-Ia.e3aab21b.png";